import { ifCanPushDatalayer, pageTypeIncludes } from "./utils/utils.dataLayer.common";
import categorizeMarketoFormSubmission from "./form-categorize-submission.common";

//UCS004
const dataLayerFormGetDemo = (userStatus, userEmail, marketoIDF) => {
    ifCanPushDatalayer({
        then: () => {
            const form = document.querySelector("[data-form-id]");
            const formID = form ? form.dataset.formId : "";

            if ((formID === "resources_details" && pageTypeIncludes("demo")) || pageTypeIncludes("gen-ai")) {
                if (userEmail) {
                    categorizeMarketoFormSubmission({
                        userEmail,
                        userStatus,
                        leadType: "get a demo",
                        marketoIDF
                    });
                }
            }
        },
    });
};
export default dataLayerFormGetDemo;
